/**
 * SEO 配置 - models (Norsk)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Fysikknøyaktig AI-videogenerator | WeryAI',
        description: 'Generer realistiske, fysikknøyaktige AI-videoer med OpenAI Sora 2 med synkronisert lyd og narrativ konsistens.',
        keywords: 'Sora 2, OpenAI Sora, videomodel, realistisk AI video, tekst til video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Kinematisk AI Videogenerator | WeryAI',
        description: 'Kling 2.5 Turbo lager kinematiske videoer med avansert linsekontroll, følelsesmessige uttrykk og jevn bevegelsesfysikk.',
        keywords: 'Kling 2.5 Turbo, Kling AI, kinematisk AI video, linsekontroll AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Avansert AI-videogenerator og -redigering | WeryAI',
        description: 'Runway Gen-4 genererer realistiske, konsistente AI-videoer med dypere promptforståelse og smarte redigeringsverktøy. Prøv det gratis på WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, AI-videogenerator, tekst til video, bilde til video, AI-videoredigering, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Videogenerator - Avansert Videoproduksjon | WeryAI',
        description: 'Generer avanserte AI-videoer med Hailuo AI på WeryAI. Har banebrytende bevegelseskontroll og realistisk rendering.',
        keywords: 'Hailuo AI, MiniMax, AI videogenerator, bevegelseskontroll, realistisk video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance AI videogenerator - Dans og bevegelse skapelse | WeryAI',
        description: 'Seedance AI videogenerator - Dans og bevegelse skapelse on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro bildegenerering | WeryAI',
        description: 'Nano Banana Pro - Google Gemini 3.0 Pro bildegenerering on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash høyhastighets tegning | WeryAI',
        description: 'Google Nano Banana - Gemini 2.5 Flash høyhastighets tegning on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI bildegenerator - Topp åpen kildekode tegnemodell | WeryAI',
        description: 'FLUX AI bildegenerator - Topp åpen kildekode tegnemodell on WeryAI. Fast and high-quality results.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Profesjonell AI tegneforbedring | WeryAI',
        description: 'FLUX.1 Kontext - Profesjonell AI tegneforbedring on WeryAI. Fast and high-quality results.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Avansert tekst-til-bilde diffusjonsmodell fra Google | WeryAI',
        description: 'Google Imagen 4 - Avansert tekst-til-bilde diffusjonsmodell fra Google on WeryAI. Fast and high-quality results.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Åpen kildekode tekst renderingsmodell fra Alibaba | WeryAI',
        description: 'Qwen Image - Åpen kildekode tekst renderingsmodell fra Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 bildegenerering - High fidelity bildemodell fra Alibaba | WeryAI',
        description: 'Wan 2.5 bildegenerering - High fidelity bildemodell fra Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDance batch 4K tegnemodell | WeryAI',
        description: 'Seedream 4.0 - ByteDance batch 4K tegnemodell on WeryAI. Fast and high-quality results.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDance alt-i-en AI bildeskapelsesmodell | WeryAI',
        description: 'Dreamina 4.0 - ByteDance alt-i-en AI bildeskapelsesmodell on WeryAI. Fast and high-quality results.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDance Flaggskip AI Bildegeneringsmodell | WeryAI',
        description: 'Seedream 4.5 er ByteDances nyeste flaggskips AI-bildemodell med fokus på presis typografi-rendering og multi-bilde fusjon med 4K ultra HD output. Prøv gratis på WeryAI.',
        keywords: 'Seedream 4.5, AI bildegenerering, typografi-rendering, bildefusjon, ByteDance, 4K kvalitet, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Topp kunstnerisk estetikk AI tegning | WeryAI',
        description: 'Midjourney - Topp kunstnerisk estetikk AI tegning on WeryAI. Fast and high-quality results.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI Video Generator - Skap Kinoklare Videoer | WeryAI',
        description: 'Skap fantastiske videoer med Runway Gen-4.5 på WeryAI. Hybrid autoregressiv-diffusjons arkitektur for presis fysikk simulering og tidsmessig konsistens.',
        keywords: 'Runway Gen-4.5, AI video generator, kinoklar AI video, fysikk simulering, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI Video Generator - Høy Kvalitet Video Skaping | WeryAI',
        description: 'Generer høy kvalitet videoer med Kling 2.6 Pro på WeryAI. Native audiovisuell generering, kinokvalitet 1080p, fremragende prompt overholdelse.',
        keywords: 'Kling 2.6 Pro, AI video generator, høy kvalitet AI video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Generator - Presis kamera kontroll og frame veiledning | WeryAI',
        description: 'Generer kinoklare AI videoer med Dreamina 3.0 (Jimeng 3.0) på WeryAI. Presis start/slutt frame kontroll, profesjonelle kamerabevegelser og 1080p høy-dynamisk video generering.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, AI video generator, kamera kontroll, start slutt frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI Video Generator - Kreativ Video Generering | WeryAI',
        description: 'Frigjør din kreativitet på WeryAI med Kling O1 AI video generator. Perfekt for å generere fantasifull og unik videoinnhold.',
        keywords: 'Kling O1, AI video generator, kreativ AI video, Kling AI, WeryAI',
    },
}
